
import axios from 'axios';
import { normalize } from 'normalizr';
import { createSlice } from '@reduxjs/toolkit';

import { channel } from '../actions/NormalizrSchema';
import * as ChannelReducer from './channelReducer';
import { setError } from './uiReducer';
import * as DataHelpers from '../helpers/DataHelpers';

// SLICE
const appointmentSlice = createSlice({
  name: 'APPOINTMENT',
  initialState: {
    appointments: [],
    appointmentCampaigns: [],
    totalAppointmentCount: 0,
    totalPages: 0,
    lastUpdatedDate: '',
    activeKey: 3,
    dropdownMenuItems: [{
      id: 1,
      label: 'Today',
      duration: 0,
    }, {
      id: 2,
      label: 'Tomorrow',
      duration: 1,
    }, {
      id: 3,
      label: 'Next 7 Days',
      duration: 6,
    }, {
      id: 4,
      label: 'Next 30 Days',
      duration: 29,
    }, {
      id: 5,
      label: 'Custom',
    }],
    loading: true,
  },
  reducers: {
    receiveAppointments: (state, action) => ({
      ...state,
      totalAppointmentCount: action.payload.appointments.totalUpcomingApptCount,
      appointments: [...action.payload.appointments.appointments.map((appointment) => {
        appointment.isChecked = false; // eslint-disable-line no-param-reassign
        return appointment;
      })],
      totalPages: action.payload.totalPageCount,
      lastUpdatedDate: action.payload.appointments.lastUpdatedAppointment ?
        action.payload.appointments.lastUpdatedAppointment.lastUpdatedAt : '',
      loading: false,
    }),
    requestData: state => ({
      ...state,
      loading: true,
    }),
    receiveError: state => ({
      ...state,
      loading: false,
    }),
  },
});

export default appointmentSlice.reducer;

// ACTIONS
export const { receiveAppointments, requestData, receiveError } = appointmentSlice.actions;

// THUNKS -- ASYNC ACTION CREATORS

export function fetchAppointments({ fromDate, toDate, pageNumber, pageSize, officeIds = null, appointmentTypeIds = null }) {
  return (dispatch) => {
    dispatch(requestData());
    const getAppointmentsViewRequests = [getAppointments(fromDate, toDate, pageNumber, pageSize, officeIds, appointmentTypeIds), ChannelReducer.getChannels()];
    return axios.all(getAppointmentsViewRequests)
      .then(axios.spread((appointments, channels) => {
        const totalPageCount = getTotalPageCount(appointments.data, pageSize);
        const normalizedChannel = normalize(channels.data, [channel]);
        dispatch(receiveAppointments(prepareAppointmentsListViewPayload(appointments.data, totalPageCount, normalizedChannel)));
      })).catch((err) => {
        dispatch(receiveError());
        dispatch(setError(err));
      });
  };
}

function getAppointments(fromDate, toDate, pageNo, pageSize, officeIds, appointmentTypeIds) {
  const params = {
    from: fromDate,
    to: toDate,
    pageNo,
    pageSize,
    officeIds,
    appointmentTypeIds,
  };
  return axios.get('/appointment/appointmentManager', {
    params,
  }).catch(err => console.error(err.response || err)); // eslint-disable-line no-console
}

function getTotalPageCount(data, pageSize) {
  const { totalUpcomingApptCount } = data;
  const totalPages = Math.ceil(totalUpcomingApptCount / pageSize);
  return totalPages;
}

// PREPARE CALLBACKS -- PAYLOAD CUSTOMIZERS

export function prepareAppointmentsListViewPayload(appointments, totalPageCount, normalizedChannel) {
  return {
    appointments: {
      ...appointments,
    },
    totalPageCount,
    channels: {
      ...normalizedChannel.entities.channels,
    },
    channelIds: [...new Set([...DataHelpers.getObjectKeys(normalizedChannel.entities.channels)])],
  };
}
